import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { openCorrectAppStore } from '../../util/ion-util';

@Component({
  selector: 'app-app-store-buttons',
  templateUrl: './app-store-buttons.component.html',
  styleUrls: ['./app-store-buttons.component.scss'],
})
export class AppStoreButtonsComponent implements OnInit {

  @Input() showAsFullPage = false;
  isIos = false;
  isAndroid = false;

  constructor(private readonly platform: Platform) {}

  ngOnInit() { 
    this.isIos = this.platform.is("ios");
    this.isAndroid = this.platform.is("android");
  }

  onClick(openAppleStore: boolean) {
    let appStoreToOpen = openAppleStore ? 'ios' : 'android';
    openCorrectAppStore(this.platform, { isRedirect: false },  appStoreToOpen);
  }
}
